import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import { Close, Message } from '@mui/icons-material';
import { Application } from '@features/applications';

type GetJobSuccessModalProps = {
  isOpen: boolean;
  application: Application | null;
  handleClose: () => void;
  setIsMessagingModalOpen: Dispatch<SetStateAction<boolean>>;
};

const GetJobSuccessModal: FC<GetJobSuccessModalProps> = ({
  isOpen,
  application,
  handleClose,
  setIsMessagingModalOpen
}) => {

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={() => {
            handleClose();
          }}
        >
          <Close />
        </IconButton>
        <br />
        {application && application.job_listing.company.s_logo_file && (
          <Avatar
            src={application.job_listing.company.s_logo_file}
            variant="square"
            sx={{
              borderRadius: 5,
              alignSelf: 'center',
              margin: 'auto',
              width: '60px',
              height: '60px',
            }}
          />
        )}
        {application &&
          <>
            <Typography variant="h4" sx={{ p: 3 }}>
              {application.job_listing.company.s_name}
            </Typography>
            <Typography variant="body1">
              {application.job_listing.company.s_city}{' '}
              {application.job_listing.company.s_state},{' '}
              {application.job_listing.company.s_zip}
            </Typography>
          </>
        }
      </DialogTitle>
      <Divider textAlign='center' sx={{ width: '100%' }} />
      <DialogContent>
        <Stack spacing={2} mb={2}>
          <Stack alignItems='center' spacing={2}>
            <Typography variant="h5">Congratulations!</Typography>
            <Typography textAlign='center'>
              You’ve been hired at <b>{application?.job_listing?.company?.s_name}</b>.
            </Typography>
          </Stack>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginTop: 1 }}
            onClick={() => setIsMessagingModalOpen(true)}
            startIcon={<Message />}
          >
            Message
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default GetJobSuccessModal;
